import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getCMSDetails } from '../../apis/apiHandler';

const ViewCmsContent = () => {
    const { tag } = useParams();
    const [activeTab, setActiveTab] = useState('en');
    const [cmsDetail, setCmsDetail] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (tag) {
            setLoading(true);
            setError(null);
            getCMSDetails({ tag: tag })
                .then((response) => {
                    if (response?.code === 200 || response?.data) {
                        setCmsDetail(response.data);
                    } else {
                        setError(response?.message || 'Failed to load content');
                    }
                })
                .catch(() => {
                    setError('Something went wrong. Please try again.');
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [tag]);

    const formattedTitle = tag ? tag.replace(/_/g, ' ') : 'CMS Page';

    if (loading) {
        return (
            <div style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem 1.5rem' }}>
                <div className="card border-0 shadow-sm" style={{ borderRadius: '12px', overflow: 'hidden' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1.5rem', borderBottom: '0.5px solid #dee2e6' }} className="placeholder-glow">
                        <span className="placeholder" style={{ width: '160px', height: '22px', borderRadius: '4px' }}></span>
                        <span className="placeholder" style={{ width: '120px', height: '34px', borderRadius: '8px' }}></span>
                    </div>
                    <div style={{ padding: '2rem 2.5rem', minHeight: '380px' }} className="placeholder-glow">
                        <span className="placeholder col-12 mb-2 d-block" style={{ height: '16px' }}></span>
                        <span className="placeholder col-10 mb-2 d-block" style={{ height: '16px' }}></span>
                        <span className="placeholder col-8 mb-4 d-block" style={{ height: '16px' }}></span>
                        <span className="placeholder col-11 mb-2 d-block" style={{ height: '16px' }}></span>
                        <span className="placeholder col-9 mb-2 d-block" style={{ height: '16px' }}></span>
                        <span className="placeholder col-12 mb-2 d-block" style={{ height: '16px' }}></span>
                        <span className="placeholder col-7 mb-2 d-block" style={{ height: '16px' }}></span>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem 1.5rem' }}>
                <div className="alert alert-danger">{error}</div>
            </div>
        );
    }

    return (
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem 1.5rem' }}>
            <div className="card border-0 shadow-sm" style={{ borderRadius: '12px', overflow: 'hidden' }}>

                {/* Top bar: title + language dropdown */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '1rem 1.5rem',
                    borderBottom: '0.5px solid #dee2e6',
                    background: '#f8f9fa'
                }}>
                    <h5 style={{
                        margin: 0,
                        fontSize: '16px',
                        fontWeight: 600,
                        textTransform: 'capitalize',
                        color: '#212529'
                    }}>
                        {formattedTitle}
                    </h5>

                    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
                        <select
                            value={activeTab}
                            onChange={(e) => setActiveTab(e.target.value)}
                            style={{
                                appearance: 'none',
                                WebkitAppearance: 'none',
                                padding: '7px 36px 7px 12px',
                                fontSize: '13px',
                                fontWeight: 500,
                                borderRadius: '8px',
                                border: '1px solid #ced4da',
                                background: '#ffffff',
                                color: '#212529',
                                cursor: 'pointer',
                                outline: 'none',
                            }}
                        >
                            <option value="en">🇬🇧 English</option>
                            <option value="ar">🇦🇪 Arabic</option>
                        </select>
                        <span style={{
                            position: 'absolute',
                            right: '12px',
                            pointerEvents: 'none',
                            fontSize: '11px',
                            color: '#6c757d'
                        }}>▾</span>
                    </div>
                </div>

                {/* English Content */}
                {activeTab === 'en' && (
                    <div
                        style={{
                            padding: '2rem 2.5rem',
                            minHeight: '380px',
                            fontSize: '15px',
                            lineHeight: '1.8',
                            color: '#444',
                            wordBreak: 'normal',
                            overflowWrap: 'break-word',
                        }}
                        dangerouslySetInnerHTML={{
                            __html: cmsDetail?.content || '<p style="color:#aaa">No content available in English.</p>'
                        }}
                    />
                )}

                {/* Arabic Content */}
                {activeTab === 'ar' && (
                    <div
                        style={{
                            padding: '2rem 2.5rem',
                            minHeight: '380px',
                            fontSize: '15px',
                            lineHeight: '1.8',
                            color: '#444',
                            direction: 'rtl',
                            textAlign: 'right',
                            wordBreak: 'normal',
                            overflowWrap: 'break-word',
                        }}
                        dangerouslySetInnerHTML={{
                            __html: cmsDetail?.content_ar || '<p style="color:#aaa">لا يوجد محتوى متاح باللغة العربية.</p>'
                        }}
                    />
                )}

            </div>
        </div>
    );
};

export default ViewCmsContent;